import React from 'react';
import UnifiedTicketTemplate from './UnifiedTicketTemplate';
import { TicketData } from '../TicketDetail';

interface ProblemDetailTemplateProps {
  ticket: TicketData;
  isReadOnly: boolean;
  activeTab: 'details' | 'approvals' | 'notes' | 'activity' | 'assessment' | 'resolution' | 'attachments';
  setActiveTab: (tab: 'details' | 'approvals' | 'notes' | 'activity' | 'assessment' | 'resolution' | 'attachments') => void;
  onRefresh: () => void;
}

const ProblemDetailTemplate: React.FC<ProblemDetailTemplateProps> = (props) => {
  return <UnifiedTicketTemplate {...props} />;
};

export default ProblemDetailTemplate;